import React, { useState } from "react";
import { Lock } from "lucide-react";
import { verifyStaffPin } from "../lib/checkinApi";
import { InstallHomeButton } from "./InstallHomeButton";

// Shared PIN screen for staff tablets (Check-in, Ristorante…)
export function StaffPinGate({ title, onUnlock }) {
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { await verifyStaffPin(pin.trim()); onUnlock(); }
    catch (ex) { setErr(ex?.response?.data?.detail || "PIN non valido"); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#4a1c17] px-4">
      <form onSubmit={submit} className="w-full max-w-sm bg-[#f7ebdf] rounded-3xl shadow-2xl p-8" data-testid="staff-pin-gate">
        <div className="flex flex-col items-center mb-5">
          <div className="h-14 w-14 rounded-full bg-[#4a1c17] flex items-center justify-center mb-3"><Lock className="h-6 w-6 text-[#f7ebdf]" /></div>
          <h1 className="font-serif text-xl font-bold text-[#2b1410]">{title}</h1>
          <p className="text-xs text-[#7c5a4e] italic mt-1">Inserisci il PIN staff</p>
        </div>
        <input type="tel" inputMode="numeric" autoFocus maxLength={8} value={pin} onChange={(e) => setPin(e.target.value)} placeholder="••••"
          className="w-full h-14 rounded-2xl border border-[#e8dcc8] bg-white text-center text-3xl tracking-[0.5em] font-mono" data-testid="staff-pin-input" />
        {err && <p className="mt-2 text-sm text-rose-700 text-center" data-testid="staff-pin-error">{err}</p>}
        <button type="submit" disabled={busy || !pin.trim()} className="mt-4 w-full h-12 rounded-2xl bg-[#4a1c17] text-white font-bold disabled:opacity-50" data-testid="staff-pin-submit">{busy ? "Verifica…" : "Entra"}</button>
        <div className="mt-4 flex justify-center"><InstallHomeButton appName={title.split("·")[0].trim()} /></div>
      </form>
    </div>
  );
}
